import React from 'react'
import {Route, Routes} from 'react-router'
import {auth_routes,dashboard_routes,public_routes} from './router.link';
// import AuthFeature from '../authFeature';
import AuthApp from '../authApp';
import FeatureApp from '../featureApp';
import { all_routes } from './all_routes';
import { Navigate } from 'react-router-dom';
import Dashboard_Feature from '../dashboardFeature';
const ALLRoutes: React.FC = () => {
  const routes = all_routes;
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={routes.home} />} />
        <Route element={<FeatureApp />}>
          {public_routes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route  element={<AuthApp />}>
          {auth_routes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route  element={<Dashboard_Feature />}>
          {dashboard_routes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
             </Routes>
    </>
  )
}
export default ALLRoutes
